@if (selectedHeader=='billingDetails') {
  <div class="infoRow col-md-12">
    <p>Organizations can only be registered once. If your organization has registered with  {{ baseSiteId == "vax" ? "VaxServe" : "VaccineShop"}}, you should
      <a class="" (click)="gotoAdduser()" href="javascript: void(0);">
        create a new user account instead.
      </a>
    </p>
    <span>
      Not sure whether your organization is registered?
    </span>
    <p>
      @if (baseSiteId != 'vax') {
        <a class="mailTo" href="mailto:vaccineshoppe.svc@sanofi.com">We can help.</a>
      }
      @if (baseSiteId == 'vax') {
        <a class="mailTo" href="mailto:VaxServe@vaxserve.com">We can help.</a>
      }
    </p>
  </div>
}

<div class="row">
  <div class="Registration-nav col-12 p0 multipleHeader">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3 payment">
      <div class="Common-registration" [ngClass]="selectedHeader=='billingDetails'?'Common-active':''">
        <span>1</span>
        <span>{{ "accountRegistration.shippingInformation.header" | cxTranslate }}</span>
      </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3">
      <div class="Common-registration" [ngClass]="selectedHeader=='shippingDetails'?'Common-active':''">
        <span>2</span>
        <span>{{ "accountRegistration.billingInformation.header" | cxTranslate }}</span>
      </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3">
      <div class="Common-registration" [ngClass]="selectedHeader=='contacts'?'Common-active':''">
        <span>3</span>
        <span>{{ "accountRegistration.contactsInformation.header" | cxTranslate }}</span>
      </div>
    </div>
    <div class="col-xs-12 col-md-12 col-lg-3 confirmation">
      <div class="Common-registration" [ngClass]="selectedHeader==null?'Common-active':''">
        <span>4</span>
        <span>{{ "accountRegistration.accountConfirmation.header" | cxTranslate }}</span>
      </div>
    </div>
  </div>
  <div class="col-md-12 col-12 brdr3Style p-0 m-0">
    @if (selectedHeader=='shippingDetails') {
      <div class="Registration-nav singleHeader">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3">
          <div class="Common-registration" [ngClass]="selectedHeader=='shippingDetails'?'Common-active':''">
            <span>2</span>
            <span>{{ "accountRegistration.billingInformation.header" | cxTranslate }}</span>
          </div>
        </div>
      </div>
    }
    @if (selectedHeader=='billingDetails') {
      <div class="Registration-nav singleHeader">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3 payment">
          <div class="Common-registration" [ngClass]="selectedHeader=='billingDetails'?'Common-active':''">
            <span>1</span>
            <span>{{ "accountRegistration.shippingInformation.header" | cxTranslate }}</span>
          </div>
        </div>
      </div>
    }
    @if (selectedHeader=='contacts') {
      <div class="Registration-nav singleHeader">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3">
          <div class="Common-registration" [ngClass]="selectedHeader=='contacts'?'Common-active':''">
            <span>3</span>
            <span>{{ "accountRegistration.contactsInformation.header" | cxTranslate }}</span>
          </div>
        </div>
      </div>
    }
    @if (selectedHeader=='confirmation') {
      <div class="Registration-nav singleHeader confirmation">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3">
          <div class="Common-registration" [ngClass]="selectedHeader=='confirmation'?'Common-active':''">
            <span>4</span>
            <span>{{ "accountRegistration.accountConfirmation.header" | cxTranslate }}</span>
          </div>
        </div>
      </div>
    }
  </div>
</div>